<script lang="ts" setup>
import {ModalsContainer} from "vue-final-modal";

const router = useRouter();
const magnoliaContext = useMagnoliaContext();

router.afterEach((to, from) => {
  if (to.path === from.path && import.meta.client) {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }
});

router.beforeResolve((to, from, next) => {
  // Disable routing when in edit mode
  if (magnoliaContext.isMagnoliaEdit) {
    const loadingIndicator = useLoadingIndicator();
    loadingIndicator.clear();
    return false;
  }
  return next();
});

const color = "var(--color-sunrise-100)";
</script>

<template>
  <NuxtLoadingIndicator :color></NuxtLoadingIndicator>
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
  <ModalsContainer />
</template>
<style lang="scss">
.page-enter-active,
.page-leave-active {
  transition: all var(--transition-duration) var(--transition-easing);
}

.page-enter-from,
.page-leave-to {
  opacity: 0;
  filter: blur(3px);
}
</style>
